import { render, staticRenderFns } from "./rcc-footer-buttons.vue?vue&type=template&id=a401dc42&"
import script from "./rcc-footer-buttons.vue?vue&type=script&lang=js&"
export * from "./rcc-footer-buttons.vue?vue&type=script&lang=js&"
import style0 from "./rcc-footer-buttons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports